import React, { useState, useEffect, useMemo } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "./Essentials/Navbar";
import Footer from "./Essentials/Footer";
import "./Css/Departments.css";
const DEPT_MAP = { AIRD: 0, CSRD: 1, CSDC: 2, VPLD: 3, GPLD: 4 };
const DEPT_TOKENS = [
  "ai ml",
  "security hack",
  "projects js android web client project react java",
  "veda ved vpld",
  "garuda grd gpld"
];

const ABOUT_DATA = ["The Department of Artificial Intelligence, undertakes all the opertaions of 'Zero Human Interaction Computation' (ZHIC). This deptarment emphasizes least human's physical and manual interaction with the system inorder to manupulate and perform operations. We undermine the human interaction power by introducing advanced voice commands to operate the system, this is a branch of Natural language processing (NLP). Here the user can operate the whole system by his/her voice commands. We program the system in such a way that it thinks similarly like a human, using the large amount of data given to the machine.This department also concentrates on a wide range of Machine learning algorithms (ML) which includes Predictions, Data processing and the other branches of ML & AI. We create sophisticated algorithms using different programming languages which are ideally meant for optimizing the user time and creating a better user experience. Here the users uses less brain power and physical power, and the AIS (AI software) takes over the system and solves user issues.",

  "Cyber security is one of the hot topic of the computer industry now-a-days, as everyone is concerned about their personal and organizational level security. Data transmitted over Internet should maintain confidentiality in it throughout its transmission from source to the desired destination. This data should be protected from the unauthorized attackers who desire to steal, sniff data over the internet, thus we encrypt the data before transmission. Encryption is the process where a normal text is converted into unreadable format, which a common user cannot understand. This message will be decrypted on the destination side using some tools. We design sophisticated algorithms which provides highly advanced encryption and decryption mechanisms which maintains your data confidential. We work on algorithms which helps in maintaining data confidential, so that it can be easily transmitted over internet.",

  "The Engineering and Solutions wing of NFRAC, Viśvakarmān Technological Center, is responsible for translating research outputs into robust and deployable software solutions. Our team handles all aspects of development, including full-stack web applications, Android and mobile development, and core systems-based projects. We leverage a wide range of programming languages, frameworks, and 3-tier architecture technologies to meet the diverse requirements of both internal initiatives and client projects. For project execution, we follow the Spiral Model (SM) strategy within the Software Development Life Cycle (SDLC), ensuring iterative development, risk management, and high-quality delivery. In addition to executing client projects, VTC operates Antar Systems, focusing on the development of in-house software that converts research innovations from NFRAC-Lab into practical, end-user solutions. We also run Vyapti Solutions, which specializes in tailored software solutions for clients, addressing specific business or operational requirements. Through this integrated approach, VTC bridges research and practical application, ensuring that NFRAC's innovations are effectively implemented and accessible to both internal teams.",

  "The Vedic language \"Sanskrit\" is well regarded as the first programming language. Sanskrit has the memory in sound, which gives cosmic power to be aligned with the energy of planets and nakshatras.\nVeda programming language (until version 1.*) is built on Java, meaning that the Veda's Interpreter (VI) code is designed using Java Programming Language, in such a way that, it explore's the syntax of the Veda source code and processes sequentially and converts the instructions into machine code using JVM.\nDue to this nature of Veda programming language, it is also known as an Interpreted language, as it executes line by line and dose not generate any object file or an intermediate code prior to execution phase. This language is basically designed to make the tasks easy, as it has a very crispy and simple syntax. Veda is very easy and simple to understand and to learn, and it is also easy to implement.",

  "GARUDA - Generating Assembly Resources Using Direct Algebra"];

const Department = () => {
  const { pathname } = useLocation();
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);

  const dept = localStorage.getItem("departmentName") || "AIRD";
  const image = localStorage.getItem("departmentImage");
  const deptIndex = DEPT_MAP[dept] ?? 0;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch("https://rohitpidishetty.github.io/NFRAC_Projects/Projects.json");
        const json = await response.json();
        processProjects(json);
      } catch (err) {
        console.error("Failed to fetch projects:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [dept]);

  const processProjects = (projectList) => {
    const tokens = DEPT_TOKENS[deptIndex].toLowerCase().split(/\s+/);
    let filteredList = [];

    Object.values(projectList).forEach((yearGroup) => {
      Object.values(yearGroup).forEach((project) => {
        let score = 0;
        project.domain.forEach((dom) => {
          if (tokens.includes(dom.toLowerCase())) score++;
        });

        if (score > 0) {
          filteredList.push({ ...project, score });
        }
      });
    });

    filteredList.sort((a, b) => b.score - a.score);
    setProjects(filteredList);
  };

  const ExtraContent = () => {
    const isMobile = window.innerWidth <= 750;
    const imgWidth = isMobile ? "100%" : "65%";

    if (deptIndex === 3) {
      return (
        <div className="extra-content">
          <h3>Anatomy:</h3>
          <img src="veda/Veda1.1_Arch.png" style={{ width: imgWidth }} alt="Veda Arch" />
          <p>The new modified version of the interpreter has BCI's (branch control instructions) which help in executing block & nested-block statements like for & if-else effectively, we have also added the DRMF (de-referenced memory fragment) that stores the set of instructions (block-statements) in an arbitrary memory location, this location will be accessed for re-executing those statements efficiently.</p>
          <br />
          <center>
            <img style={{ width: imgWidth }} src='veda/Veda1.2_Arch.png' />
          </center>
          <br />
          <p>This is an example of processing the block statements in Veda Programming Language</p>
          <center>
            <img style={{ width: imgWidth }} src='veda/Execution.png' />
          </center>
          <p>The VPLD department has decided to migrate Veda's interpreter from Java to C, for efficient source code interpretation, this new version of the Interpreter is expected to be released in the year 2025 as Veda 2.0 which will be based on C along with CPP (GNU __cpp_compiled).</p>
          <p>Veda 2.0 Memory layout, <br />A 4096-B O(1) generic-memory along with CFMA technology is being used for storing the data (variables & objects).</p>
          <br />
          <p><b>Memory layout of new interpreter, Veda 2.0</b></p>
          <p>
          </p>
          <img src="veda/Veda2.0_Memory.png" style={{ width: imgWidth }} alt="Veda 2.0" />
        </div>
      );
    }

    if (deptIndex === 4) {
      return (
        <div className="extra-content">
          <a href="https://github.com/rohitpidishetty/garuda-source-codes" className="apple-link">Garuda Source Codes</a>
          <p>GARUDA is a powerful programming language that represents Generating Assembly Resources Using Direct Algebra. Development is underway, currently building pre-obj libraries for linker routine. GARUDA will be released under Open Source GNU General Public License v3 as Garuda v1.0 in 8 months, by December 2025. Looking forward to sharing the essence of Garuda Programming Language (GPL) with you all. This journey is going to be amazing, GPL will remain proprietary software to NFRAC lab until stabilization. Then I'll decide to make it open source to grow the GARUDA community and look forward to work with some brilliant minds. Cheers !!!</p>
          <p><b>Anatomy:</b></p>
          <center>
            <img style={{ width: imgWidth }} src='garuda/garuda_arch_0_1.png' />
          </center>
          <p>Unveiling the initial architecture v 0.0.1 of GARUDA --v 0.1 programming language. It took me a for-loop to come up with this diagram yet I came up with this very seamlessly complicated system design. The GARUDA itself is a software that is being built using advanced java programming where as the core libraries are being designed in c program for low latency and faster execution, these libraries are then linked to the pre-obj code using linkers. The CLI/Shell pipe-line is a crucial step where different programming paradigms are pipe-lined together for po code's execution. In the compilation phase I have included many steps that aid to construct the pre-obj code using the CTDA Compile time data area where all the necessary data i.e, variables, definitions, etc., is stored.</p>
          <div>
            <b>Garuda Updates</b>
            <p>list{"<int | str | float>, dict<int | str, int | str | float>"} modules have been integrated successfully to GARUDAs compiler and seamless compilation achieved ✅️. Our high level data structures come with Reference Locking System (RLS) that helps programmer to lock the variables if necessary, this RLS ensures security and prevents data from being tampered. Literally enjoying this journey and if everything goes well then India will be no far to have its first indigenous programming language GARUDA as a successor of VEDA.</p>

            <p>GARUDA's compiler is so robust that some of the libraries for GARUDA programming language are being built by GARUDA programming language itself. For example here is the definition of a method in garuda language that converts simple text into capitalized text and also a method that adds to numbers together. Deemed to be bharats 🇮🇳 new programming language, jai Hind.</p>
          </div>
          <div className="social-embeds">
            <iframe src="https://www.linkedin.com/embed/feed/update/urn:li:ugcPost:7326840697611833345?collapsed=1" width={isMobile ? "100%" : "50%"} height="500"></iframe>
          </div>
          <p>Here am I with fully functional nested conditional statements in GARUDA programming language 👨‍💻</p>
          <div className="social-embeds">
            <iframe src="https://www.linkedin.com/embed/feed/update/urn:li:ugcPost:7330806584580759552?collapsed=1" width={isMobile ? "100%" : "50%"} height="500"></iframe>
          </div>
          <p>GARUDA's compiler is so robust that some of the libraries for GARUDA programming language are being built by GARUDA programming language itself. For example here is the definition of a method in garuda language that converts simple text into capitalized text and also a method that adds to numbers together. Deemed to be bharats 🇮🇳 new programming language, jai Hind.</p>
          <div className="social-embeds">
            <iframe src="https://www.linkedin.com/embed/feed/update/urn:li:share:7334122762636013568?collapsed=1" width={isMobile ? "100%" : "50%"} height="500"></iframe>
          </div>
        </div>
      );
    }
    return null;
  };

  return (
    <div className="page-wrapper">
      <Navbar />
      <main className="container">
        <header className="dept-header">
          <h1>{`Department of ${dept}`}</h1>
        </header>

        <section className="hero-split">
          <div className="image-container">
            <img src={image} alt={dept} className="main-dept-img" />
          </div>

          <div className="project-list-scroll">
            {loading ? <p>Loading projects...</p> : projects.map((item, idx) => (
              <div key={idx} className="project-card">
                <h3>{idx + 1}. {item.title.split('.').pop()}</h3>
                <p><strong>Description:</strong> {item.description}</p>
                <a href={item.link} target="_blank" rel="noreferrer">
                  {window.innerWidth > 750 ? item.link : "Visit Project →"}
                </a>
              </div>
            ))}
          </div>
        </section>

        <section className="about-section">
          <h2>About {`${dept} Department`}</h2>
          <p className="description-text">{ABOUT_DATA[deptIndex]}</p>
          <ExtraContent />
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default Department;